import { render, staticRenderFns } from "./spotWelcome.vue?vue&type=template&id=94bc9322&scoped=true"
import script from "./spotWelcome.vue?vue&type=script&lang=js"
export * from "./spotWelcome.vue?vue&type=script&lang=js"
import style0 from "./spotWelcome.vue?vue&type=style&index=0&id=94bc9322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bc9322",
  null
  
)

export default component.exports